import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';
import { Picklist, actions } from '@groove-labs/groove-ui';
import {
  AUTO_IMPORT_FIELDS,
  AUTO_IMPORT_GROUP_ID,
} from 'Modules/FlowsShow/constants/index.ts';
import {
  reports as getReports,
  getInitialAutoImportReport,
} from 'Modules/PeopleImportDialog/submodules/reports/selectors';
import { fetchFlowOwnerOptionsBegin } from 'Modules/FlowsShow/actions/fetchFlowOwnerOptions';

const { updateFieldValue } = actions.form;
@connect(
  state => {
    return {
      reports: getReports(state),
      selectedReport: getInitialAutoImportReport(state),
    };
  },
  {
    fetchFlowOwnerOptionsBegin,
    updateFieldValue,
  }
)
export default class ReportPicklist extends Component {
  static propTypes = {
    reports: PropTypes.instanceOf(List).isRequired,
    selectedReport: PropTypes.instanceOf(Map).isRequired,

    // passed props
    maxMenuHeight: PropTypes.number,
    groupId: PropTypes.string.isRequired,
    fetchFlowOwnerOptionsBegin: PropTypes.func.isRequired,
  };

  static defaultProps = {
    maxMenuHeight: null,
  };

  constructor(props) {
    super(props);
    const { fetchFlowOwnerOptionsBegin, selectedReport } = props;

    if (!selectedReport.isEmpty()) {
      fetchFlowOwnerOptionsBegin({
        reportSfdcId: selectedReport.get('value'),
      });
    }
  }

  getLabel = option => option.get('label');

  handleOnChangeReport = option => {
    const { fetchFlowOwnerOptionsBegin } = this.props;
    const reportSfdcId = option.get('value');

    if (reportSfdcId) {
      fetchFlowOwnerOptionsBegin({
        reportSfdcId,
      });

      updateFieldValue({
        groupId: AUTO_IMPORT_GROUP_ID,
        fieldId: AUTO_IMPORT_FIELDS.ASSIGN_CUSTOM_OWNER,
        value: false,
      });
    }
  };

  render() {
    const { groupId, reports, selectedReport, maxMenuHeight } = this.props;

    return (
      <Picklist
        groupId={groupId}
        fieldId={AUTO_IMPORT_FIELDS.REPORT}
        label={
          reports.size
            ? 'Select a Report'
            : 'No reports found in selected folder'
        }
        options={reports}
        getOptionLabel={this.getLabel}
        initialValue={!selectedReport.isEmpty() && selectedReport}
        isDisabled={reports.isEmpty()}
        maxMenuHeight={maxMenuHeight}
        onChange={this.handleOnChangeReport}
      />
    );
  }
}
